export const mutations = {
  SET_ORGS(state, orgs) {
    state.orgs = orgs
  },
  SET_SELECTED_ORG(state, org) {
    state.selectedOrg = org === null || org === undefined ? null : org.toString()
    try {
      if (state.selectedOrg) {
        localStorage.setItem('selectedOrgId', state.selectedOrg)
      } else {
        localStorage.removeItem('selectedOrgId')
      }
    } catch (e) {
      // storage unavailable (private mode / quota) — selection still works in-memory
    }
  },
  ADD_ORG(state, org) {
    state.orgs.push(org)
  },
  SET_CURRENT (state, current) {
    if (state.orgs.length === 1) {
      current = state.orgs[0]
    }
    state.current = current
  },
  SET_CURRENT_MEMBERS (state, data) {
    state.currentMembers = Array.isArray(data) ? data : data.organization_members || []
  },
  REMOVE_MEMBER (state, orgMemberId) {
    state.currentMembers = state.currentMembers.filter(m => m.organization_member_id !== orgMemberId)
  },
  UPDATE_MEMBER (state, member) {
    const index = state.currentMembers.findIndex(m => m.organization_member_id === member.organization_member_id)
    if (index !== -1) {
      state.currentMembers = [
        ...state.currentMembers.slice(0, index),
        member,
        ...state.currentMembers.slice(index + 1)
      ]
    }
  },
  SET_CURRENT_INVITES (state, invites) {
    state.currentInvites = invites
  },
  ADD_INVITE(state, invite) {
    state.currentInvites.push(invite)
  },
  REMOVE_INVITE(state, inviteId) {
    state.currentInvites = state.currentInvites.filter(i => i.id !== inviteId)
  },
  SET_PENDING_INVITES(state, invites) {
    state.pendingInvites = invites
  },
  REMOVE_PENDING_INVITE(state, inviteId) {
    state.pendingInvites = state.pendingInvites.filter(i => i.id !== inviteId)
  },

  RESET_CURRENT (state) {
    state.current = null
    state.currentMembers = []
    state.currentInvites = []
  },
  SET_APIKEYS (state, payload) {
    state.apikeys = payload
  },
  REMOVE_APIKEY (state, payload) {
    state.apikeys = state.apikeys.filter(a => a.uuid !== payload)
  },
  ADD_APIKEY (state, payload) {
    state.apikeys.push(payload)
  }
}
